import { Component, Host, h, State, Prop } from '@stencil/core';

@Component({
  tag: 'search-block',
  styleUrl: 'search-block.css',
  shadow: false,
})
export class SearchBlock {
  @State() searchQuery: string = new URLSearchParams(window.location.search).get('s') || '';
  @Prop() theme: string;

  handleInputChange(event) {
    this.searchQuery = event.target.value;
  }

  render() {
    //console.log(this.searchQuery);
    return (
      <Host>
        <div class={`search-container  ${this.theme}`}>
          <div class={`search-box ${this.theme}`}>
            <h2 class="search-page-title"></h2>
            <form role="search" method="get" id="searchform" class="searchform" action="/">
              <div class="search-page-bar-wrapper ">
                <label id="searchLabel" class="relative">
                  <input
                    class="search-page-bar !text-white"
                    type="text"
                    name="s"
                    id="s"
                    placeholder="Search 3Eco.com..."
                    value={this.searchQuery}
                    onInput={event => this.handleInputChange(event)}
                    autocomplete="off"
                  />
                  <button type="submit" class="search-page-submit search-icon  " id="searchsubmit">
                  </button>
                </label>
                <button class="search-page-clear" type="reset" onClick={() => (this.searchQuery = '')}>
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </Host>
    );
  }
}
